import { render, staticRenderFns } from "./appealOrder.vue?vue&type=template&id=4fd55a78&scoped=true"
import script from "./appealOrder.vue?vue&type=script&lang=js"
export * from "./appealOrder.vue?vue&type=script&lang=js"
import style0 from "./appealOrder.vue?vue&type=style&index=0&id=4fd55a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd55a78",
  null
  
)

export default component.exports